/**
 * Pure helpers of the Generate flow (spec 027).
 */
import type { PictureSlot, SlotUse } from '../../../../Shared/src/@types';
import { useLabel, type PictureScene } from '../../../../Shared/src/pictures';

export interface PlaceChoice {
  use: SlotUse;
  label: string;
}

/**
 * "Place in": the slot's sprite and background uses (line uses carry no
 * picture and follow their sprite), each labelled as 026's `slotPlaces`
 * labels it: a sprite with lines in its scene by those lines.
 */
export function placeChoices(slot: Pick<PictureSlot, 'uses'>, scenes: readonly PictureScene[]): PlaceChoice[] {
  const out: PlaceChoice[] = [];
  for (const use of slot.uses) {
    if (use.kind === 'line') continue;
    const scene = scenes.find((s) => s.key === use.scene);
    const name = scene ? scene.doc.name || scene.name : '';
    const sprite = use.spriteId ? scene?.doc.sprites?.find((x) => x.id === use.spriteId) : undefined;
    const lines = use.kind === 'sprite'
      ? slot.uses.filter((u) => u.kind === 'line' && u.scene === use.scene && u.spriteId === use.spriteId)
      : [];
    const label = lines.length > 0 ? lines.map((u) => useLabel(u, name, sprite)).join(', ') : useLabel(use, name, sprite);
    out.push({ use, label });
  }
  return out;
}

export const useKey = (u: SlotUse): string => `${u.kind}|${u.scene}|${u.spriteId ?? ''}`;
